import React, { useEffect, useState } from 'react'
import { Toolbar as MuiToolbar } from '@mui/material'
import Controls from '../../../components/Entry/Controls'
import ProvinceService from '../services/Provinces'
import { useAuth } from '../../../applications/hooks/UseAuth'
import UserService from '../../users/services/User'

const useStyles = {
    NavigateProvince: {
        borderRadius: 10,
        borderColor: '#0FCB8F',
        borderWidth: 2,
        background: '#FFF',
        width: '100%',
        fontSize: 15,
        padding: '3px 6px 2px 5px'
    },
    toolBarContainer: {
        marginBottom: '10px',
        minHeight: 'auto'
    }
}

// Définition des niveaux pour itération
const LEVELS = ['region', 'district', 'commune', 'fkt', 'village']

function ProvinceFilter({ filter, setFilter, setNeedLoad, needSite = false, width = '40%', hideTitle = true }) {
    const { user } = useAuth()
    const classes = useStyles

    const userService = UserService.load()
    const provinceService = ProvinceService.load()

    const [provinceData, setProvinceData] = useState([])
    const [lists, setLists] = useState({
        region: [],
        district: [],
        commune: [],
        fkt: [],
        village: []
    })
    const [selected, setSelected] = useState({
        region: null,
        district: null,
        commune: null,
        fkt: null,
        village: null
    })
    const [isUserRegions, setIsUserRegions] = useState(false)

    useEffect(() => {
        userService.getUserRegion(user.id).then((response) => {
            if (response) {
                setProvinceData([response.region])
                setLists({
                    region: [response.region],
                    district: response.region.District || [],
                    commune: [],
                    fkt: [],
                    village: []
                })
                setSelected((prev) => ({ ...prev, region: response.region.id }))
                setIsUserRegions(true)
            } else {
                provinceService.getProvinces().then((res) => {
                    if (res?.data?.regions) {
                        setProvinceData(res.data.regions)
                        setLists((prev) => ({ ...prev, region: res.data.regions }))
                    }
                })
            }
        })
    }, [])

    const handleSelect = (level, value) => {
        const newSelected = { ...selected, [level]: value || null }

        const levelIndex = LEVELS.indexOf(level)
        for (let i = levelIndex + 1; i < LEVELS.length; i++) {
            newSelected[LEVELS[i]] = null
        }

        const newLists = { ...lists }
        if (level === 'region') {
            const regionObj = provinceData.find((r) => r.id === value)
            newLists.district = regionObj?.District || []
            newLists.commune = []
            newLists.fkt = []
            newLists.village = []
        } else if (level === 'district') {
            const districtObj = lists.district.find((d) => d.id === value)
            newLists.commune = districtObj?.Commune || []
            newLists.fkt = []
            newLists.village = []
        } else if (level === 'commune') {
            const communeObj = lists.commune.find((c) => c.id === value)
            newLists.fkt = communeObj?.Fokontany || []
            newLists.village = []
        } else if (level === 'fkt') {
            const fktObj = lists.fkt.find((f) => f.id === value)
            newLists.village = fktObj?.Village || []
        }

        setSelected(newSelected)
        setLists(newLists)

        const newFilter = { ...filter }
        LEVELS.forEach((lvl) => {
            if (newSelected[lvl]) newFilter[lvl] = newSelected[lvl]
            else delete newFilter[lvl]
        })
        setFilter(newFilter)
        setNeedLoad(true)
    }

    return (
        <MuiToolbar style={{ padding: 0, ...classes.toolBarContainer, width }}>
            <div className="flex flex-row gap-4" style={classes.NavigateProvince}>
                <Controls.AutoCompleteSelect
                    name="region"
                    label="Régions"
                    options={lists.region}
                    labelKey="name"
                    valueKey="id"
                    value={selected.region}
                    onChange={(e) => handleSelect('region', e.target.value)}
                    isDisabled={isUserRegions}
                    // hideTitle={hideTitle}
                />
                <Controls.AutoCompleteSelect
                    name="district"
                    label="Districts"
                    options={lists.district}
                    labelKey="name"
                    valueKey="id"
                    value={selected.district}
                    onChange={(e) => handleSelect('district', e.target.value)}
                    isDisabled={!lists.district.length}
                    // hideTitle={hideTitle}
                />
                {needSite && (
                    <>
                        <Controls.AutoCompleteSelect
                            name="commune"
                            label="Communes"
                            options={lists.commune}
                            labelKey="name"
                            valueKey="id"
                            value={selected.commune}
                            onChange={(e) => handleSelect('commune', e.target.value)}
                            isDisabled={!lists.commune.length}
                            hideTitle={hideTitle}
                        />
                        <Controls.AutoCompleteSelect
                            name="fkt"
                            label="Fokontany"
                            options={lists.fkt}
                            labelKey="name"
                            valueKey="id"
                            value={selected.fkt}
                            onChange={(e) => handleSelect('fkt', e.target.value)}
                            isDisabled={!lists.fkt.length}
                            hideTitle={hideTitle}
                        />
                        <Controls.AutoCompleteSelect
                            name="village"
                            label="Villages"
                            options={lists.village}
                            labelKey="name"
                            valueKey="id"
                            value={selected.village}
                            onChange={(e) => handleSelect('village', e.target.value)}
                            isDisabled={!lists.village.length}
                            hideTitle={hideTitle}
                        />
                    </>
                )}
            </div>
        </MuiToolbar>
    )
}

export default ProvinceFilter
